import {
  Box,
  Checkbox, FormControlLabel, Grid, Stack, TextField, Typography,
} from '@mui/material';
import { useContext } from 'react';
import { ImagesContext } from '../../../../contexts/ImagesContext';
import BlockData from '../../../../models/BlockData';
import LinkData from '../../../../models/LinkData';
import { URLOpenType } from '../../../../models/URLOpenType';
import Utils from '../../../../utils/Utils';
import BlockCarouselItemData from '../../../Blocks/BlockCarousel/BlockCarouselItemData';
import CloseButton from '../../../Buttons/Close';
import ImageComponent from '../../../ImageComponent';
import LinkComponent from '../../../Link/LinkComponent';
import ImageModal from '../../ImageModal/ImageModal';

interface CarouselItemProps {
  item: BlockCarouselItemData;
  blockData: BlockData[];
  isTemplate: boolean;
  isEditing: boolean;
  onRemoveBlock: () => void;
  onChangeImage: (url: string) => void;
  onChangeLink: (link: LinkData) => void;
  onChangeAlt: (alt: string) => void;
}

function CarouselItem({
  item,
  blockData,
  isTemplate,
  isEditing,
  onRemoveBlock,
  onChangeImage,
  onChangeLink,
  onChangeAlt,
}: CarouselItemProps) {
  const { images } = useContext(ImagesContext);

  const handleLinkEnable = (isEnabled: boolean) => {
    if (isEnabled) {
      onChangeLink(LinkData.getDefault());
    } else {
      onChangeLink(undefined);
    }
  };

  return (
    <Stack
      sx={{
        border: '1px dashed lightGray',
        p: 2,
        position: 'relative',
        height: 'auto',
      }}
    >
      <CloseButton updateHandler={onRemoveBlock} />

      <Grid container alignContent="start" justifyContent="center">
        <Grid item xs={4} sx={[Utils.hoverBorder(isEditing), { height: '200px' }]}>
          <ImageModal
            disabled={isTemplate || !isEditing}
            images={images}
            handleOnConfirm={(url: string) => onChangeImage(url)}
          >
            <ImageComponent src={item.image.value} />
          </ImageModal>
        </Grid>

        <Grid item xs={8} sx={{ paddingLeft: 2, minHeight: '100%' }}>
          <Grid container direction="column" justifyContent="start" sx={{ height: '100%' }}>
            <FormControlLabel
              label="この画像にリンクを設定する"
              control={(
                <Checkbox
                  checked={!!item.link}
                  onChange={(event) => handleLinkEnable(event.target.checked)}
                />
              )}
            />
            {item.link !== undefined && (
              <LinkComponent
                link={item.link}
                blockData={blockData}
                hideRemoveButton
                hideTitle
                onChangeLink={(url) => {
                  onChangeLink({ ...item.link, linkData: { ...item.link.linkData, url } });
                }}
                onSelectBlock={(url) => {
                  onChangeLink({ ...item.link, linkData: { ...item.link.linkData, url } });
                }}
                onChangeTargetType={(targetType) => {
                  onChangeLink({ ...item.link, linkData: { ...item.link.linkData, targetType } });
                }}
                onChangeOpenType={(checked) => {
                  const openType = checked ? URLOpenType.NEW_TAB : URLOpenType.SAME_PAGE;
                  onChangeLink({ ...item.link, linkData: { ...item.link.linkData, openType } });
                }}
              />
            )}

            <Grid container direction="column">
              <Box sx={{ height: '42px', display: 'flex', alignItems: 'center' }}>
                <Typography>
                  alt（代替テキスト）の設定
                </Typography>
              </Box>
              <TextField
                label="画像が表示されない時の代替テキスト"
                defaultValue={item.image.alt}
                onChange={(event) => onChangeAlt(event.target.value)}
                size="small"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Stack>
  );
}

export default CarouselItem;
